import React from 'react'
import PropTypes from 'prop-types'
import { FeatureList } from 'components/molecules'
import { TextBox, DataTd, DataTh } from 'components/atoms'
import * as Styled from './Equipment.styles'
import { TextContext, useTextContext } from 'hocs'

const Equipment = ({
  constructionYear,
  renovation,
  items,
  training,
  additionalInfo,
  personalEquipment,
  qualifications,
  table,
}) => {
  const textContext = useTextContext(TextContext)

  return (
    <>
      {constructionYear && (
        <p>
          <b>{constructionYear}</b>
        </p>
      )}
      {renovation && (
        <TextBox title={ renovation.title }>
          <span
            dangerouslySetInnerHTML={{
              __html: renovation.content,
            }}
          />
        </TextBox>
      )}
      {Array.isArray(items) && items.length > 0 && (
        <FeatureList
          itemList={ [{ headline: '', items }] }
          listClass={ 'list-checkmark' }
        />
      )}
      {additionalInfo && (
        <TextBox title={ textContext['equipment.additionalInfo.title'] }>
          <span
            dangerouslySetInnerHTML={{
              __html: additionalInfo,
            }}
          />
        </TextBox>
      )}
      {table && (
        <TextBox title={ table.title }>
          <Styled.Table>
            <thead>
              <tr>
                <DataTh>Pflegegrad</DataTh>
                <DataTh>Personalschlüssel</DataTh>
              </tr>
            </thead>
            <tbody>
              {table.data.map((data, index) => (
                <tr key={ `equipment-table-${ index }` }>
                  <DataTd>{data.level}</DataTd>
                  <DataTd>{data.key}</DataTd>
                </tr>
              ))}
            </tbody>
          </Styled.Table>
          <br />
          <span
            dangerouslySetInnerHTML={{
              __html: personalEquipment.content,
            }}
          />
        </TextBox>
      )}
      {personalEquipment && (
        <TextBox title={ personalEquipment.title }>
          <span
            dangerouslySetInnerHTML={{
              __html: personalEquipment.content,
            }}
          />
        </TextBox>
      )}
      {qualifications && (
        <TextBox title={ qualifications.title }>
          <span
            dangerouslySetInnerHTML={{
              __html: qualifications.content,
            }}
          />
        </TextBox>
      )}
      {training && (
        <TextBox title={ textContext['equipment.training.title'] }>
          <span
            dangerouslySetInnerHTML={{
              __html: training,
            }}
          />
        </TextBox>
      )}
    </>
  )
}

Equipment.propTypes = {
  constructionYear: PropTypes.string,
  renovation: PropTypes.shape({
    title: PropTypes.string,
    content: PropTypes.string,
  }),
  personalEquipment: PropTypes.shape({
    title: PropTypes.string,
    content: PropTypes.string,
  }),
  qualifications: PropTypes.shape({
    title: PropTypes.string,
    content: PropTypes.string,
  }),
  items: PropTypes.arrayOf(PropTypes.string),
  additionalInfo: PropTypes.string,
  training: PropTypes.string,
  table: PropTypes.shape({
    title: PropTypes.string,
    content: PropTypes.string,
    data: PropTypes.arrayOf(
      PropTypes.shape({
        level: PropTypes.string,
        key: PropTypes.string,
      })
    ),
  }),
}

export default Equipment
